var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlobalisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 -33 511.99963 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 219.4631051242,
    cy: 119.419908439,
    gradientUnits: "userSpaceOnUse",
    r: 283.0645420214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4852,
    stopColor: "#f8f5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7593,
    stopColor: "#f5ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#f1dffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1507573192,
    x2: 695.2046742502,
    xlinkHref: "#lg1",
    y1: 104.1165230398,
    y2: 617.1544972112
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6918915606,
    x2: 633.4781285114,
    xlinkHref: "#lg1",
    y1: 121.2541743252,
    y2: 560.1004052448
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientTransform: "matrix(0 1.003922 1.003922 0 -.000368 -33.376518)",
    gradientUnits: "userSpaceOnUse",
    x1: 127.2885,
    x2: 680.1741,
    xlinkHref: "#lg1",
    y1: 149.271,
    y2: 660.3046
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientTransform: "matrix(0 1.003922 1.003922 0 -.000368 -33.376518)",
    gradientUnits: "userSpaceOnUse",
    x1: 145.7572,
    x2: 618.6886,
    xlinkHref: "#lg1",
    y1: 166.3416,
    y2: 603.4734
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 128.9394583842,
    x2: -20.5771548808,
    xlinkHref: "#lg1",
    y1: 268.3022437844,
    y2: 229.5785628316
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 515.3078753822,
    x2: 465.4689708298,
    xlinkHref: "#lg1",
    y1: 229.0277108302,
    y2: 180.2645087008
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#02e3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#08d7ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#12c2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#21a698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8029,
    stopColor: "#338189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#495577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 481.7383299774,
    x2: 384.3911257956,
    xlinkHref: "#lg2",
    y1: 143.691730633,
    y2: 111.959764057
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 169.4499197126,
    x2: 222.253907892,
    xlinkHref: "#lg2",
    y1: 212.7037383258,
    y2: 364.0752982702
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 276.1902196952,
    x2: 220.2560027198,
    xlinkHref: "#lg1",
    y1: 406.9795112154,
    y2: 168.9003124452
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 346.5277056046,
    x2: 316.1034478258,
    xlinkHref: "#lg3",
    y1: 195.3735348008,
    y2: 164.9493774142
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 354.9537233428,
    x2: 311.1734880604,
    xlinkHref: "#lg1",
    y1: 203.799552539,
    y2: 160.0194176488
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 324.3870090322,
    x2: 344.2393657978,
    y1: 173.2329386206,
    y2: 193.0852953862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 172.2709405326,
    x2: 141.8466827538,
    xlinkHref: "#lg3",
    y1: 148.9549925024,
    y2: 118.5307347236
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 180.6969582708,
    x2: 136.9167229884,
    xlinkHref: "#lg1",
    y1: 157.3809098484,
    y2: 113.6007749582
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1302439602,
    x2: 169.982701118,
    xlinkHref: "#lg4",
    y1: 126.81429593,
    y2: 146.6667530878
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0243796806,
    x2: 351.600222294,
    xlinkHref: "#lg3",
    y1: 359.9493796346,
    y2: 329.5251218558
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: 390.4503974188,
    x2: 346.6702625286,
    xlinkHref: "#lg1",
    y1: 368.3753973728,
    y2: 324.5951620904
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear17",
    gradientUnits: "userSpaceOnUse",
    x1: 359.8837835004,
    x2: 379.736140266,
    xlinkHref: "#lg4",
    y1: 337.8086830622,
    y2: 357.66114022
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear18",
    gradientUnits: "userSpaceOnUse",
    x1: 371.4331029728,
    x2: 341.008845194,
    xlinkHref: "#lg3",
    y1: 87.8077097576,
    y2: 57.3834519788
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear19",
    gradientUnits: "userSpaceOnUse",
    x1: 379.859120711,
    x2: 336.0788854286,
    xlinkHref: "#lg1",
    y1: 96.2336271036,
    y2: 52.4534922134
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    stopColor: "#ab9ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#9f9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "#8c9beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6178,
    stopColor: "#709aef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7686,
    stopColor: "#4d99f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    stopColor: "#2297fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear20",
    gradientUnits: "userSpaceOnUse",
    x1: 349.2924064004,
    x2: 369.1448635582,
    xlinkHref: "#lg5",
    y1: 65.6670131852,
    y2: 85.519470343
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear21",
    gradientUnits: "userSpaceOnUse",
    x1: 185.1788676476,
    x2: 154.7546098688,
    xlinkHref: "#lg3",
    y1: 380.386922534,
    y2: 349.9626647552
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear22",
    gradientUnits: "userSpaceOnUse",
    x1: 193.6047849936,
    x2: 149.8246501034,
    xlinkHref: "#lg1",
    y1: 388.81283988,
    y2: 345.0327049898
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear23",
    gradientUnits: "userSpaceOnUse",
    x1: 163.0381710752,
    x2: 182.890628233,
    xlinkHref: "#lg5",
    y1: 358.2462259616,
    y2: 378.0985827272
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m490.488281 222.625c0 122.675781-99.449219 222.121094-222.125 222.121094s-222.125-99.445313-222.125-222.121094 99.449219-222.125 222.125-222.125 222.125 99.449219 222.125 222.125zm0 0",
    fill: "url(#radial0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m416.980469 222.625c0-122.675781-66.539063-222.125-148.617188-222.125s-148.617187 99.449219-148.617187 222.125 66.539062 222.121094 148.617187 222.121094 148.617188-99.445313 148.617188-222.121094zm0 0",
    fill: "url(#linear0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m337.878906 222.625c0-122.675781-31.125-222.125-69.515625-222.125s-69.515625 99.449219-69.515625 222.125 31.125 222.121094 69.515625 222.121094 69.515625-99.445313 69.515625-222.121094zm0 0",
    fill: "url(#linear1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m490.488281 222.625c0-82.082031-99.449219-148.617188-222.125-148.617188s-222.125 66.535157-222.125 148.617188c0 82.078125 99.449219 148.617188 222.125 148.617188s222.125-66.539063 222.125-148.617188zm0 0",
    fill: "url(#linear2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m490.488281 222.625c0-38.394531-99.449219-69.515625-222.125-69.515625s-222.125 31.121094-222.125 69.515625c0 38.390625 99.449219 69.511719 222.125 69.511719s222.125-31.121094 222.125-69.511719zm0 0",
    fill: "url(#linear3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m348.144531 238.285156c-2.042969-2.941406-4.929687-5.390625-8.585937-6.941406l-42.921875-18.191406c-14.695313-6.230469-30.382813 6.472656-27.347657 22.140625l2.003907 10.347656c-15.976563 3.164063-31.808594 5.609375-47.304688 7.339844l-145.675781-145.390625c-20.351562 33.550781-32.074219 72.925781-32.074219 115.035156 0 17.054688 1.941407 33.65625 5.582031 49.605469l166.933594 166.933593c15.953125 3.644532 32.550782 5.582032 49.609375 5.582032 77.738281 0 146.136719-39.945313 185.824219-100.417969zm0 0",
    fill: "url(#linear4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m440.671875 176.671875c-7.585937 5.929687-9.347656 16.699219-4.03125 24.730469.886719 1.335937 1.929687 2.5 3.066406 3.523437l48.625 48.628907c1.410157-10.109376 2.15625-20.433594 2.15625-30.929688 0-30.300781-6.078125-59.175781-17.058593-85.496094-4.023438 12.195313-15.371094 25.945313-32.757813 39.542969zm0 0",
    fill: "url(#linear5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m510.847656 116.046875c-6.710937-33.742187-41.347656-58.355469-97.550781-69.304687-3.914063-.765626-7.917969-1.460938-11.984375-2.074219 20.050781 15.003906 37.476562 33.3125 51.484375 54.113281.363281.214844.71875.421875 1.074219.625 11.746094 6.917969 19.019531 15.070312 20.757812 23.835938.851563 4.304687.429688 8.960937-1.203125 13.886718-4.019531 12.195313-15.367187 25.945313-32.753906 39.542969-7.589844 5.929687-9.347656 16.699219-4.03125 24.730469 5.9375 8.964844 18.273437 11 26.742187 4.371094 9.167969-7.175782 17.09375-14.527344 23.726563-21.980469 16.371094-18.394531 24.890625-37.414063 24.890625-55.988281 0-3.949219-.375-7.863282-1.152344-11.757813zm0 0",
    fill: "url(#linear6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m339.558594 231.34375-42.921875-18.191406c-14.695313-6.230469-30.382813 6.472656-27.347657 22.140625l2.003907 10.347656c-60.800781 12.042969-119.5625 13.75-165.527344 4.789063-27.523437-5.371094-48.304687-14.351563-59.503906-25.269532-4.808594-4.679687-7.84375-9.722656-8.886719-14.980468-1.988281-10.039063 3.003906-22.074219 13.878906-34.691407 5.257813-24.363281 14.519532-47.242187 27.050782-67.90625-4.679688 2.753907-9.183594 5.570313-13.53125 8.457031-47.726563 31.613282-70.328126 67.601563-63.613282 101.335938 4.570313 22.996094 22.125 41.757812 50.640625 54.835938 13.316407 6.109374 29.011719 10.984374 46.898438 14.46875 21.675781 4.214843 45.769531 6.3125 71.394531 6.3125 34.109375 0 70.910156-3.71875 108.226562-11.097657l.871094 4.5c3.035156 15.667969 22.335938 21.59375 33.640625 10.328125l33.019531-32.910156c10.023438-9.988281 6.734376-26.949219-6.292968-32.46875zm0 0",
    fill: "url(#linear7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m454.183594 344.332031c-39.683594 60.476563-108.082032 100.414063-185.820313 100.414063-17.058593 0-33.65625-1.933594-49.609375-5.582032l-166.933594-166.929687v-.011719c13.320313 6.097656 29.003907 10.972656 46.878907 14.457032 21.675781 4.214843 45.769531 6.3125 71.390625 6.3125 34.109375 0 70.917968-3.722657 108.234375-11.101563l.871093 4.507813c3.03125 15.660156 22.332032 21.589843 33.636719 10.328124l33.023438-32.917968c7.207031-7.183594 7.527343-17.972656 2.289062-25.523438zm0 0",
    fill: "url(#linear8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m351.90625 179.597656c0 11.683594-9.472656 21.15625-21.15625 21.15625s-21.152344-9.472656-21.152344-21.15625 9.46875-21.15625 21.152344-21.15625 21.15625 9.472656 21.15625 21.15625zm0 0",
    fill: "url(#linear9)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m340.238281 170.617188c-2.382812-2.515626-5.746093-4.09375-9.488281-4.09375-7.21875 0-13.070312 5.851562-13.070312 13.074218 0 3.738282 1.578124 7.101563 4.09375 9.484375l25.34375 25.339844c2.378906 2.519531 5.746093 4.097656 9.484374 4.097656 7.21875 0 13.070313-5.855469 13.070313-13.074219 0-3.738281-1.578125-7.101562-4.09375-9.484374zm0 0",
    fill: "url(#linear10)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m343.824219 179.597656c0 7.21875-5.851563 13.074219-13.074219 13.074219-7.21875 0-13.070312-5.855469-13.070312-13.074219s5.851562-13.074218 13.070312-13.074218c7.222656 0 13.074219 5.855468 13.074219 13.074218zm0 0",
    fill: "url(#linear11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m177.648438 133.179688c0 11.683593-9.46875 21.152343-21.152344 21.152343s-21.15625-9.46875-21.15625-21.152343c0-11.683594 9.472656-21.15625 21.15625-21.15625s21.152344 9.472656 21.152344 21.15625zm0 0",
    fill: "url(#linear12)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m165.980469 124.199219c-2.382813-2.515625-5.746094-4.09375-9.484375-4.09375-7.222656 0-13.074219 5.851562-13.074219 13.074219 0 3.738281 1.578125 7.101562 4.09375 9.484374l25.34375 25.339844c2.382813 2.519532 5.746094 4.097656 9.484375 4.097656 7.21875 0 13.074219-5.855468 13.074219-13.074218 0-3.738282-1.578125-7.101563-4.097657-9.484375zm0 0",
    fill: "url(#linear13)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m169.566406 133.179688c0 7.21875-5.851562 13.070312-13.070312 13.070312-7.222656 0-13.074219-5.851562-13.074219-13.070312 0-7.222657 5.851563-13.074219 13.074219-13.074219 7.21875 0 13.070312 5.851562 13.070312 13.074219zm0 0",
    fill: "url(#linear14)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m387.402344 344.171875c0 11.683594-9.46875 21.15625-21.152344 21.15625s-21.15625-9.472656-21.15625-21.15625 9.472656-21.152344 21.15625-21.152344 21.152344 9.46875 21.152344 21.152344zm0 0",
    fill: "url(#linear15)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m375.734375 335.195312c-2.382813-2.519531-5.746094-4.097656-9.484375-4.097656-7.222656 0-13.074219 5.855469-13.074219 13.074219 0 3.738281 1.578125 7.101563 4.09375 9.484375l25.34375 25.34375c2.382813 2.515625 5.746094 4.09375 9.484375 4.09375 7.21875 0 13.074219-5.851562 13.074219-13.074219 0-3.738281-1.578125-7.101562-4.097656-9.484375zm0 0",
    fill: "url(#linear16)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m379.320312 344.171875c0 7.222656-5.851562 13.074219-13.070312 13.074219-7.222656 0-13.074219-5.851563-13.074219-13.074219 0-7.21875 5.851563-13.070313 13.074219-13.070313 7.21875 0 13.070312 5.851563 13.070312 13.070313zm0 0",
    fill: "url(#linear17)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m376.8125 72.03125c0 11.683594-9.472656 21.15625-21.15625 21.15625s-21.152344-9.472656-21.152344-21.15625 9.46875-21.15625 21.152344-21.15625 21.15625 9.472656 21.15625 21.15625zm0 0",
    fill: "url(#linear18)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m365.140625 63.050781c-2.382813-2.515625-5.746094-4.09375-9.484375-4.09375-7.21875 0-13.074219 5.851563-13.074219 13.074219 0 3.738281 1.578125 7.101562 4.097657 9.484375l25.339843 25.339844c2.382813 2.519531 5.746094 4.097656 9.488281 4.097656 7.21875 0 13.070313-5.855469 13.070313-13.074219 0-3.738281-1.578125-7.101562-4.09375-9.484375zm0 0",
    fill: "url(#linear19)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m368.730469 72.03125c0 7.21875-5.851563 13.074219-13.074219 13.074219-7.21875 0-13.074219-5.855469-13.074219-13.074219s5.855469-13.074219 13.074219-13.074219c7.222656 0 13.074219 5.855469 13.074219 13.074219zm0 0",
    fill: "url(#linear20)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m190.558594 364.609375c0 11.683594-9.472656 21.15625-21.15625 21.15625s-21.15625-9.472656-21.15625-21.15625 9.472656-21.152344 21.15625-21.152344 21.15625 9.46875 21.15625 21.152344zm0 0",
    fill: "url(#linear21)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m178.886719 355.632812c-2.382813-2.519531-5.746094-4.097656-9.484375-4.097656-7.21875 0-13.074219 5.855469-13.074219 13.074219 0 3.742187 1.578125 7.101563 4.097656 9.484375l25.339844 25.34375c2.382813 2.515625 5.746094 4.09375 9.484375 4.09375 7.222656 0 13.074219-5.851562 13.074219-13.070312 0-3.742188-1.578125-7.105469-4.09375-9.488282zm0 0",
    fill: "url(#linear22)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m182.476562 364.609375c0 7.222656-5.855468 13.074219-13.074218 13.074219s-13.074219-5.851563-13.074219-13.074219c0-7.21875 5.855469-13.074219 13.074219-13.074219s13.074218 5.855469 13.074218 13.074219zm0 0",
    fill: "url(#linear23)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobalisation);
export default __webpack_public_path__ + "static/media/icon-globalisation.e2e8538cd3f41b64d2db745192ba2706.svg";
export { ForwardRef as ReactComponent };